import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=b6d6f10e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=b6d6f10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d6f10e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d6f10e')) {
      api.createRecord('b6d6f10e', component.options)
    } else {
      api.reload('b6d6f10e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=b6d6f10e&scoped=true&", function () {
      api.rerender('b6d6f10e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zypf7LvVuO6Z/JS/comp/PopupDialog.vue"
export default component.exports